import styled from 'styled-components';

export const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
`;

export const Navbar = styled.div`
  padding: ${({ theme }) => theme.landingSpacing.md};
  width: 100%;
  position: fixed;
  top: 0;
  background: ${({ theme }) => theme.landing.navbarBg};
  backdrop-filter: blur(24px);
  border-bottom: 1px solid ${({ theme }) => theme.landing.navbarBorder};
  transition: all 0.3s ease;
  z-index: 1000;
`;

export const NavContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Logo = styled.img`
  height: 40px;
  width: auto;
  max-width: 160px;
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
  cursor: pointer;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    height: 50px;
    max-width: 200px;
  }
`;

export const ThemeToggleButton = styled.button`
  width: 32px;
  height: 32px;
  cursor: pointer;
  border-radius: ${({ theme }) => theme.landingBorderRadius.full};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  border: 1px solid ${({ theme }) => theme.landing.text};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    width: 32px;
    height: 32px;
  }

  &:hover {
    opacity: 0.8;
  }

  svg {
    width: 24px;
    height: 24px;
    fill: currentColor;
  }
`;

export const LightModeIcon = styled.svg`
  display: ${({ $isDark }) => ($isDark ? 'none' : 'block')};
`;

export const DarkModeIcon = styled.svg`
  display: ${({ $isDark }) => ($isDark ? 'block' : 'none')};
`;

export const HeroSection = styled.div`
  width: 100%;
  height: 100vh;
  padding: ${({ theme }) => theme.landingSpacing.xl} ${({ theme }) => theme.landingSpacing.sm};
  background: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.landing.gradientFrom},
    ${({ theme }) => theme.landing.gradientVia},
    ${({ theme }) => theme.landing.gradientTo}
  );
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HeroContent = styled.div`
  text-align: center;
  text-transform: capitalize;
`;

export const HeroTitle = styled.h1`
  font-size: 3rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  color: ${({ theme }) => theme.landing.text};
  line-height: 1.1;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 4.5rem;
  }
`;

export const HeroSubtitle = styled.p`
  margin-top: ${({ theme }) => theme.landingSpacing.xl};
  font-size: 1.125rem;
  font-weight: 500;
  color: ${({ theme }) => theme.landing.textSecondary};
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.25rem;
  }
`;

export const CTAButton = styled.a`
  display: inline-block;
  margin-top: ${({ theme }) => theme.landingSpacing.xl};
  background: ${({ theme }) => theme.landing.buttonBg};
  color: white;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.md};
  text-decoration: none;
  transition: background 0.3s ease;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
  }
`;

export const SignInButton = styled.button`
  background: ${({ theme }) => theme.landing.buttonBg};
  margin-left: 10px;
  color: white;
  font-weight: 500;
  padding: ${({ theme }) => theme.landingSpacing.md} ${({ theme }) => theme.landingSpacing.lg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  transition: background 0.3s ease;
  border: none;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
`;

export const ContentSection = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: ${({ theme }) => theme.landingSpacing.xl} ${({ theme }) => theme.landingSpacing.sm};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.landing.background};
  color: ${({ theme }) => theme.landing.text};
  transition: all 0.3s ease;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.xxxl} ${({ theme }) => theme.landingSpacing.xxxl};
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: 5rem 12.5rem;
  }
`;

export const SectionHeader = styled.h2`
  font-size: 1.875rem;
  font-weight: 600;
  border-left: 4px solid ${({ theme }) => theme.landing.buttonBg};
  padding-left: ${({ theme }) => theme.landingSpacing.sm};
  color: ${({ theme }) => theme.landing.text};
`;

export const SectionText = styled.p`
  font-size: 1.0625rem;
  margin-top: ${({ theme }) => theme.landingSpacing.sm};
  color: ${({ theme }) => theme.landing.textSecondary};
  line-height: 1.6;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    font-size: 1.0625rem;
  }
`;

export const ContactSection = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: ${({ theme }) => theme.landingSpacing.xl} ${({ theme }) => theme.landingSpacing.sm};
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    to bottom right,
    ${({ theme }) => theme.landing.gradientFrom},
    ${({ theme }) => theme.landing.gradientVia},
    ${({ theme }) => theme.landing.gradientTo}
  );
  transition: all 0.3s ease;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    padding: ${({ theme }) => theme.landingSpacing.xxxl} ${({ theme }) => theme.landingSpacing.xxxl};
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    padding: 5rem 12.5rem;
  }
`;

export const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.landingSpacing.xxl};

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ContactInfo = styled.div`
  color: ${({ theme }) => theme.landing.text};
`;

export const ContactTitle = styled.h2`
  font-size: 2.25rem;
  font-weight: 600;
  border-left: 4px solid ${({ theme }) => theme.landing.buttonBg};
  padding-left: ${({ theme }) => theme.landingSpacing.sm};
  color: ${({ theme }) => theme.landing.text};
`;

export const ContactDescription = styled.p`
  margin-top: ${({ theme }) => theme.landingSpacing.sm};
  font-size: 1rem;
  color: ${({ theme }) => theme.landing.textSecondary};
  line-height: 1.5;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.sm}) {
    font-size: 1.25rem;
  }
`;

export const ContactDetails = styled.div`
  margin-top: ${({ theme }) => theme.landingSpacing.xl};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};
`;

export const ContactItem = styled.div``;

export const ContactLabel = styled.p`
  font-weight: 500;
  color: ${({ theme }) => theme.landing.text};
`;

export const ContactValue = styled.p`
  color: ${({ theme }) => theme.landing.textSecondary};
`;

export const FormCard = styled.div`
  border-radius: ${({ theme }) => theme.landingBorderRadius.xl};
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: ${({ theme }) => theme.landingSpacing.xl};
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  transition: all 0.3s ease;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${({ theme }) => theme.landingSpacing.xl};

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const FormGroup = styled.div``;

export const FormLabel = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  display: block;
`;

export const Required = styled.span`
  color: ${({ theme }) => theme.landing.errorColor};
`;

export const FormInput = styled.input`
  margin-top: ${({ theme }) => theme.landingSpacing.xs};
  width: 100%;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.md};
  background: ${({ theme }) => theme.landing.inputBg};
  border: 1px solid ${({ theme }) => theme.landing.inputBorder};
  color: ${({ theme }) => theme.landing.text};
  transition: all 0.3s ease;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.landing.buttonBg}33;
  }
`;

export const FormTextarea = styled.textarea`
  margin-top: ${({ theme }) => theme.landingSpacing.xs};
  width: 100%;
  height: 150px;
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  padding: ${({ theme }) => theme.landingSpacing.sm};
  background: ${({ theme }) => theme.landing.inputBg};
  border: 1px solid ${({ theme }) => theme.landing.inputBorder};
  color: ${({ theme }) => theme.landing.text};
  transition: all 0.3s ease;
  resize: vertical;

  &::placeholder {
    color: ${({ theme }) => theme.landing.textMuted};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.landing.buttonBg};
    box-shadow: 0 0 0 2px ${({ theme }) => theme.landing.buttonBg}33;
  }
`;

export const FormActions = styled.div`
  margin-top: ${({ theme }) => theme.landingSpacing.xl};
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  background: ${({ theme }) => theme.landing.buttonBg};
  color: white;
  font-weight: 500;
  padding: ${({ theme }) => theme.landingSpacing.sm} ${({ theme }) => theme.landingSpacing.lg};
  border-radius: ${({ theme }) => theme.landingBorderRadius.md};
  transition: background 0.3s ease;
  border: none;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.landing.buttonHover};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.8;
  }
`;

export const AcknowledgementSection = styled.div`
  padding: ${({ theme }) => theme.landingSpacing.md};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.landingSpacing.md};
  background: ${({ theme }) => theme.landing.background};
  color: ${({ theme }) => theme.landing.textSecondary};
  transition: all 0.3s ease;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    flex-direction: row;
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    flex-direction: row;
  }
`;

export const AcknowledgementText = styled.div`
  line-height: 1.6;
`;

export const AcknowledgementImage = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 200px;
    transition: all 0.3s ease;

    @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
      width: 150px;
    }

    @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
      width: 100px;
    }
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.landingSpacing.md};
  background: ${({ theme }) => theme.landing.background};
  color: ${({ theme }) => theme.landing.textSecondary};
  transition: all 0.3s ease;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.landingSpacing.md};
`;

export const FooterContent = styled.div``;

export const FooterText = styled.p`
  font-size: 0.875rem;

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    font-size: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.landingBreakpoints.lg}) {
    font-size: 1rem;
  }
`;

export const FooterLink = styled.a`
  color: ${({ theme }) => theme.landing.linkColor};
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.landing.linkHover};
    text-decoration: underline;
  }
`;

export const FooterLinks = styled.p`
  font-size: 0.75rem;
  margin-top: ${({ theme }) => theme.landingSpacing.xs};

  a {
    color: ${({ theme }) => theme.landing.footerText};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const FooterWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  justify-content: space-between;
  /* grid-template-columns: 1.2fr 0.8fr 1fr; */
  grid-template-columns: 1fr 1fr;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const FooterLeftSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-right: 2rem;
  /* border-right: 1px solid ${({ theme }) => theme.colors.border}; */

  @media (max-width: 1024px) {
    padding-right: 0;
    border-right: none;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding-bottom: 1.5rem;
  }
`;

export const AcknowledgementFooterText = styled.p`
  font-size: 0.95rem;
  line-height: 1.6;
  color: #d1d9e3;
  margin: 0;
  text-align: justify;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    line-height: 1.5;
  }
`;

export const FooterCopyright = styled.p`
  font-size: 0.9rem;
  color: #a0aec0;
  margin: 0.5rem 0 0 0;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const FooterPolicies = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.landing.footerText};
  margin: 0;

  a {
    color: ${({ theme }) => theme.landing.footerText};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #4a9eff;
    }
  }

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
`;

export const FooterCenterSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 2rem;
  /* border-right: 1px solid ${({ theme }) => theme.colors.border}; */

  @media (max-width: 1024px) {
    border-right: none;
    padding: 0 0rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    padding-bottom: 1.5rem;
    justify-content: flex-start;
  }
`;

export const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

export const SocialIcon = styled.a`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: ${({ theme }) => theme.landingBorderRadius.full};
  background: ${({ theme }) => theme.landing.iconBg};
  color: ${({ theme }) => theme.landing.iconText};

  svg {
    width: 24px;
    height: 24px;
  }

  &:hover {
    background-color: rgba(74, 158, 255, 0.2);
    color: #4a9eff;
    border-color: #4a9eff;
    transform: translateY(-3px);
  }

  @media (max-width: 768px) {
    width: 45px;
    height: 45px;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const FooterRightSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: flex-end;

  @media (max-width: 1024px) {
    align-items: flex-start;
  }

  @media (max-width: 768px) {
    gap: 1rem;
    align-items: flex-start;
  }
`;

export const FlagsContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 0.75rem;
  }
`;

export const FlagImage = styled.img`
  width: 100px;
  height: 65px;
  object-fit: cover;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #4a9eff;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 85px;
    height: 55px;
  }
`;

export const AppStoresContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: 1024px) {
    justify-content: flex-start;
  }

  @media (max-width: 768px) {
    gap: 0.75rem;
  }
`;
